/**
 *
 * @author Juan Rico
 * @module Ovace
 * @description  Este módulo define el la pagina simulacion ovace.
 * permite realizar la simulacion de ovace
 *
 */

//#region  Importaciones necesarias para el la pagina de ovace.
import React, { useState, useEffect, useContext } from "react"; // Importa React y hooks.
import "./ovace.css"; // importacion de la hoja de estilos para esta pagina
import { isMobile, isDesktop, isTablet } from "react-device-detect"; // functiones para detectar tipos de dispositivos
import Header from "../../components/Header/Header"; // Componente de la cabezera de la pagina.
import NSSwitcher from "../../components/NSButton/Types/Switcher"; // Componente para botones de tipo switch
import NSBoolean from "../../components/NSButton/Types/Boolean"; // Componente para botones de tipo Boleano
import NSTimer from "../../components/NSButton/Types/Timer"; // Componente para botones de tipo Tiempo
import NSCounter from "../../components/NSButton/Types/Counter"; // Componente para botones de tipo Contadores
import NSIndicator from "../../components/NSButton/Types/Indicator"; // Componente para botones de tipo indicador
import OutlinedButton from "../../components/NSButton/Types/OutlinedButton"; // Componente para botones de tipo outlined
import NSToggle from "../../components/NSButton/Types/Toogle";
import { faStopwatch } from "@fortawesome/free-solid-svg-icons"; //importa iconos de fontawesome
import DialogVentilaciones from "../../components/DialogVentilaciones/DialogVentilaciones"; // Componente para Pop-up de las ventilaciones
import DialogDownNotes from "../../components/DialogDownNotes/DialogDownNotes"; // Componente para Pop-up de las notas
import DialogFinish from "../../components/DialogFinish/DialogFinish"; // Componente para Pop-up de finalizacion
import DialogPediatrico from "../../components/DialogPediatrico/DialogPediatrico";

import {
  iconAvisaEquipo,
  iconNotas,
  iconNino,
  Ic_exit_green,
  Ic_golpesespalda,
  Ic_tos,
} from "../../helpers/ImagesCache"; //Iconos especificos cargados en cache por el desarrolador
import { ContextoReset, GlobalContext } from "../../helpers/Context"; // Contextos de linea de tiempo y global.
import axios from "axios"; // Librería para realizar solicitudes HTTP.
import {
  BASEURLAPI,
  ComponentOptions,
  TimelineDefault,
  DEVMODE,
  PlatformMobile,
} from "../../helpers/Constants"; //importa constantes
import DialogHabilidades from "../../components/DialogHabilidades/DialogHabilidades"; // Componente para Pop-up de hailidades luego de finalizar el caso
import DialogNoTecnicas from "../../components/DialogNoTecnicas/DialogNoTecnicas"; // Componente para Pop-up de habilidades no tecnicas
import DialogCalidadRcp from "../../components/DialogCalidadRcp/DialogCalidadRcp"; // Componente para Pop-up de calidad RCP
import DialogMedirAmbas from "../../components/DialogMedirAmbas/DialogMedirAmbas"; // Componente para Pop-up de medir ambas
import Loader from "../../components/Loader/Loader"; //importa componente loader para procesos de espera
import { useNavigate } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";
import SimpleButton from "../../components/NSButton/Types/SimpleButton";
import useBeforeUnload from "../../hooks/useBeforeUnload";

//#endregion

const Ovace = () => {
  const T = useTranslation();
  const navigation = useNavigate();
  //#region ############## CONSTANTES LOCALES ESTATICAS ##############//
  /**
   * Vaor por defecto para los handles de temporizador
   * @type {Object}
   */
  const defaultTimerHandleValue = {
    startAt: +new Date(),
    stopAt: +new Date(),
    ritmo: [],
  };
  //#endregion

  //#region ############## USO DEL CONTEXTO GLOBAL ##############//
  /**
   * Contexto global
   * @type {Object}
   */
  const ctxReset = useContext(ContextoReset);

  /**
   * Contexto global
   * @type {Object}
   */
  const globalCtx = useContext(GlobalContext);
  //#endregion

  //#region ############## VARIABLES DE ESTADO PARA CONTEXTO LOCAL ##############//
  /**
   * Variable de estado para la linea de tiempo incia constante
   * @type {Object}
   */
  const [ctxTimeline, setCtxTimeLine] = useState(TimelineDefault);

  /**
   * Variable de estado para el historial
   * @type {Array}
   * @default []
   */
  const [History, setHistory] = useState([]);
  //#endregion

  //#region ############## VARIABLES DE ESTADO GENERALES ##############//

  /**
   * Variable de estado para controlar el inicio del caso
   * @type {Boolean}
   * @default false
   */
  const [complete, setComplete] = useState(false);

  /**
   * Variable de estado para controlar el inicio del caso
   * @type {Boolean}
   * @default false
   */
  const [pediatric, setPediatric] = useState(false);

  /**
   * Variable de estado para controlar el inicio del caso
   * @type {Boolean}
   * @default true
   */
  const [conscious, setConscious] = useState(true);

  /**
   * Variable de estado para controlar el inicio del caso
   * @type {Boolean}
   * @default false
   */
  const [IsStarted, setIsStarted] = useState(false);

  /**
   * Variable de estado para forzar la detencio del caso
   * @type {Boolean}
   * @default false
   */
  const [ForceStopCase, setForceStopCase] = useState(false);

  /**
   * Variable de estado para intentar detener el caso - falta explicarla bien
   * @type {Boolean}
   * @default false
   */
  const [IsTryingToStop, setTsTryingToStop] = useState(false);

  /**
   * Variable de estado para mostrar el popup de compresiones
   * @type {Boolean}
   * @default true
   */
  const [IsPopupComp, setIsPopupComp] = useState(true);

  /**
   * Variable de estado para mostrar el popup de evaluar ritmo
   * @type {Boolean}
   * @default false
   */
  const [IsPopupRitmo, setIsPopupRitmo] = useState(false);

  /**
   * Variable de estado para mostrar el popup de notas
   * @type {Boolean}
   * @default false
   */
  const [IsPopupNotas, setIsPopupNotas] = useState(false);

  /**
   * Variable de estado para mostrar el popup de habilidades tecnicas
   * @type {Boolean}
   * @default false
   */
  const [IsPopupHabilidades, setIsPopupHabilidades] = useState(true);

  /**
   * Variable de estado para mostrar el popup de habilidades no tecnicas
   * @type {Boolean}
   * @default false
   */
  const [IsPopUpNoTecnicas, setIsPopUpNoTecnicas] = useState(false);

  /**
   * Variable de estado para mostrar el popup de calidad rcp
   * @type {Boolean}
   * @default false
   */
  const [IsPopUpCalidadRcp, setIsPopUpCalidadRcp] = useState(false);

  /**
   * Variable de estado para mostrar el popup de medir ambas
   * @type {Boolean}
   * @default false
   */
  const [IsPopUpMedirAmbas, setIsPopUpMedirAmbas] = useState(false);

  /**
   * Variable de estado para mostrar el popup de finalizar reporte para guardarlo
   * @type {Boolean}
   * @default false
   */
  const [IsPopUpFinish, setIsPopUpFinish] = useState(false);

  /**
   * Variable de estado para determinar si se mediran o no las compresiones
   * @type {Boolean}
   * @default false
   */
  const [compresions, setCompresions] = useState(false);

  /**
   * Variable de estado para guardar el id del usuario actual
   * @type {Number}
   * @default 2
   */
  const [userId, setUserId] = useState(2);

  /**
   * Estado que almacena si hay algun recurso en proceso para bloquear la pantalla a interacciones
   * @type {boolean}
   * @default false - al iniciar esta oculto
   */
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Estado que almacena si hay algun recurso en proceso para bloquear la pantalla a interacciones
   * @type {string}
   * @default 'Guardando informe ...' - al iniciar tiene el texto 'Guardando informe...'
   */
  const [loadingText, setLoadingText] = useState("Guardando informe ...");

  // Hook para prevenir navegación hacia atrás durante simulación activa
  const isSimulationActive = IsStarted && !ForceStopCase;
  useBeforeUnload(isSimulationActive, "¿Estás seguro de que quieres abandonar? Los datos de la simulación se perderán.");
  //#endregion

  //#region ############## FUNCIONES HANDLE BASICAS ##############//
  /**
   * Manejador del estado forceStopCase
   * @function handleForceStopCase
   * @param boolean - value
   */
  const handleForceStopCase = (value) => setForceStopCase(value);

  /**
   * Manejador del estado IsStarted para activarlo
   * @function handleStart
   */
  const handleStart = () => setIsStarted(true);

  /**
   * Manejador del estado IsStarted para deshabilitar el caso
   * @function handleStop
   */
  const handleStop = () => {
    setIsStarted(false);
  };

  /**
   * Manejador del estado IsTryingToStop para cambiar su estado en modo toggle
   * @function handleStopDialog
   */
  const handleStopDialog = () => {
    setTsTryingToStop(!IsTryingToStop);
  };

  /**
   * Manejador del estado isPopUpActive para desactivarlo
   * @function handleCloseDialog
   */
  const handleCloseDialog = () => setIsPopupComp(false);

  /**
   * Manejador del estado IsPopupNotas para cambiar su estado en modo toggle
   * @function handleNotasDialog
   */
  const handleNotasDialog = () => setIsPopupNotas(!IsPopupNotas);

  /**
   * Manejador del estado IsPopUpNoTecnicas para cambiar su estado a true
   * @function handleDialogNoTecnicas
   */
  const handleDialogNoTecnicas = () => {
    setIsPopUpNoTecnicas(true);
  };

  /**
   * Manejador del estado IsPopUpCalidadRcp para cambiar su estado a true
   * @function handleDialogCalidadRcp
   */
  const handleDialogCalidadRcp = () => {
    setIsPopUpCalidadRcp(true);
  };

  /**
   * Manejador del estado IsPopUpMedirAmbas para cambiar su estado a true
   * @function handleDialogMedirAmbas
   */
  const handleDialogMedirAmbas = () => {
    setIsPopUpMedirAmbas(true);
  };

  /**
   * Manejador del estado IsPopUpFinish para cambiar su estado en modo toggle
   * @function handleDialogFinish
   */
  const handleDialogFinish = () => {
    setIsPopUpFinish(true);
    // TEST setIsPopUpFinish(!IsPopUpFinish)
  };

  /**
   * Manejador del estado IsPopUpFinish para cambiar su estado a false
   * @function handleDialogFinishStop
   */
  const handleDialogFinishStop = () => {
    setIsPopUpFinish(false);
  };

  /**
   * Manejador del estado IsPopUpNoTecnicas para cambiar su estado a false
   * @function handleVolverNoTecnicas
   */
  const handleVolverNoTecnicas = () => {
    setIsPopUpNoTecnicas(false);
  };

  /**
   * Manejador del estado isPopUpCalidadRco para cambiar su estado a false
   * @function handleVolverCalidadRcp
   */
  const handleVolverCalidadRcp = () => {
    setIsPopUpCalidadRcp(false);
  };

  /**
   * Manejador del estado para cerrar las habilidades no tecnicas
   * @function handleDialogNoTecnicasStop
   */
  const handleDialogNoTecnicasStop = () => {
    setIsPopUpNoTecnicas(false);
    setIsPopupHabilidades(false);
  };

  /**
   * Manejador del estado para cerrar la calidad rcp
   * @function handleDialogCalidadRcpStop
   */
  const handleDialogCalidadRcpStop = () => {
    setIsPopUpCalidadRcp(false);
    setIsPopupHabilidades(false);
  };

  /**
   * Manejador del estado para cerrar medir ambas
   * @function handleMedirAmbasStop
   */
  const handleMedirAmbasStop = () => {
    setIsPopUpMedirAmbas(false);
    setIsPopupHabilidades(false);
  };

  /**
   * Manejador del estado  para setear la medicion de compresiones activas
   * @function handleCompresions
   */
  const handleCompresions = () => {
    setIsPopupComp(false);
    setPediatric(true);
  };

  /**
   * Manejador del estado para finalizar las habilidades no tecnicas
   * y pasar al resumen del reporte
   * @function handleSaveAndCloseNotecnicas
   */
  const handleSaveAndCloseNotecnicas = () => {
    setIsPopUpNoTecnicas(false);
    setIsPopupHabilidades(false);
    handleDialogFinish();
    //SaveReport()
  };

  /**
   * Manejador del estado para finalizar las habilidades no tecnicas
   * y pasar al resumen del reporte
   * @function handleSaveAndCloseNotecnicas
   */
  const handleDialogMedirAmbasConfirm = () => {
    setIsPopUpNoTecnicas(false);
    setIsPopupHabilidades(false);
    setIsPopUpMedirAmbas(false);
    handleDialogFinish();
    //SaveReport()
  };

  /**
   * Manejador del estado para finalizar la calidad rcp
   * y pasar al resumen del reporte
   * @function handleSaveAndCloseCalidadRcp
   */
  const handleSaveAndCloseCalidadRcp = () => {
    setIsPopUpCalidadRcp(false);
    setIsPopupHabilidades(false);
    handleDialogFinish();
  };
  //#endregion

  //#region ############## FUNCIONES HANDLE AVANZADOS DE COMPONENTES ##############
  /**
   * Handle utilizado para gestionar la accion del inicio
   * del cronometro del boton INICIAR CASO
   *
   * @function handleStartTimerCase
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStartTimerCase = (_value = defaultTimerHandleValue) => {
    updateContext("startCase", _value.startAt);
    updateHistory("startCase", _value.startAt, "Inicio de Caso");
    handleStart();
  };

  /**
   * Handle utilizado para gestionar la accion de detener
   * del cronometro del boton DETENER CASO
   *
   * @function handleStopTimerCase
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStopTimerCase = (_value = defaultTimerHandleValue) => {
    handleForceStopCase(true);
    updateContext("startCase", _value.startAt);
    updateContext("stopCase", _value.stopAt);
    updateHistory("stopCase", _value.stopAt, "Fin del Caso");
    handleStop();
    handleStopDialog();
  };

  /**
   * Handle utilizado iniciar la parada cardio respiratoria
   * tiene un cronometro en el boton INICIO PCR
   *
   * @function handleStartTimerPCR
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStartTimerPCR = (_value = defaultTimerHandleValue) => {
    updateContextPush("PCR", {
      start: _value.startAt,
    });
    updateHistory("PCR", _value.startAt, "Inicio PCR");
  };

  /**
   * Handle utilizado para detener la parada cardio respiratoria
   * detiene el cronometro para entrar en modo RCE
   *
   * @function handleStopTimerPCR
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStopTimerPCR = (_value = defaultTimerHandleValue) => {
    updateContextPush("RCE", {
      start: _value.startAt,
      stop: _value.stopAt,
    });
    updateHistory("RCE", _value.stopAt, "RCE");
  };

  /**
   * Handle utilizado para gestionar la accion del switch Escenario seguro
   *
   * @function handleIsSafeSceneSwitch
   * @param _value object - nulleable
   * @default null
   */
  const handleIsSafeSceneSwitch = (value = null) => {
    updateContext("isSafeScene", value);
    updateHistory("isSafeScene", +new Date(0), "Escenario seguro");
  };

  /**
   * Handle utilizado para gestionar la accion del switch Grita Ayuda
   *
   * @function handleShouteHelpSwitch
   * @param _value object - nulleable
   * @default null
   */
  const handleShouteHelpSwitch = (value = null) => {
    updateContext("shoutedHelp", value);
    updateHistory("shoutedHelp", +new Date(), "Grita Ayuda");
  };

  /**
   * Handle utilizado para gestionar la accion del switch Canula de Guedel
   *
   * @function handleGuedelCannula
   * @param _value object - nulleable
   * @default null
   */
  const handleGuedelCannula = (value = null) => {
    updateContext("guedelCannula", value);
    updateHistory("guedelCannula", +new Date(), "Canula de Guedel");
  };
  /**
   * Handle utilizado para gestionar ç
   * la accion del boton NO RESPONDE
   *
   * @function hanldeNotResposeButton
   * @param _value object - nulleable
   * @default null
   */
  const hanldeNotResposeButton = (value = null) => {
    if (value) {
      updateContext("toser", +new Date());
    }
    updateHistory("toser", +new Date(), "Animar a toser");
  };

  /**
   * Handle utilizado para gestionar ç
   * la accion del boton NO RESPONDE
   *
   * @function handleCompleteToggle
   * @param _value object - nulleable
   * @default null
   */
  const handleCompleteToggle = (value = null) => {
    if (value.active == 0) {
      setComplete(false);
    } else if (value.active == 1) {
      setComplete(true);
    }
    updateContext("complete", value.active == 1);
    updateHistory(
      "complete",
      +new Date(),
      `Evaluacion ${value.active ? "Completa " : "Incompleta "}`
    );
  };

  /**
   * Handle utilizado para gestionar
   * la accion del boton NO RESPONDE
   *
   * @function handleConsciousToggle
   * @param _value object - nulleable
   * @default null
   */
  const handleConsciousToggle = (value = null) => {
    if (value.active == 0) {
      setConscious(false);
    } else if (value.active == 1) {
      setConscious(true);
    }
    updateContext("conscious", value.active == 1);
    updateHistory(
      "conscious",
      +new Date(),
      `El paciente esta ${value.active ? "Consciente " : "Inconsciente "}`
    );
  };

  /**
   * Handle utilizado para gestionar ç
   * la accion del boton NO RESPONDE
   *
   * @function hanldeNotifiesEmergencyTeamButton
   * @param _value object - nulleable
   * @default null
   */
  const hanldeNotifiesEmergencyTeamButton = (value = null) => {
    if (value) {
      updateContext("notifiesEmergencyTeam", +new Date());
    }
    updateHistory(
      "notifiesEmergencyTeam",
      +new Date(),
      "Avisa equipo de emergencias"
    );
  };

  /**
   * Handle utilizado para gestionar la accion del inicio
   * del cronometro del boton COMPRESIONES
   *
   * @function handleOpenAirWayStartCounter
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleOpenAirWayStartCounter = (_value = defaultTimerHandleValue) => {
    updateContextPush("backBlows", {
      start: _value.startAt,
      stop: _value.stopAt,
    });
    updateHistory(
      "backBlows", //key
      _value.startAt, //tiempo
      "Golpes en la espalda" // titulo
    );
  };
  /**
   * Handle utilizado para gestionar la accion de detener
   * del cronometro del boton COMPRESIONES
   *
   * @function handleOpenAirWayStopCounter
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleOpenAirWayStopCounter = (_value = defaultTimerHandleValue) => {
    updateContextPush("backBlows", {
      start: _value.startAt,
      stop: _value.stopAt,
    });

    updateHistory(
      "backBlows", //key
      _value.stopAt, //tiempo
      "Golpes en la espalda" // titulo
    );
  };

  /**
   * Handle utilizado para gestionar la accion del inicio
   * del cronometro del boton COMPRESIONES
   *
   * @function handleCheckVentilationStartCounter
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleCheckVentilationStartCounter = (
    _value = defaultTimerHandleValue
  ) => {
    updateContextPush("compressionsAbs", {
      start: _value.startAt,
      stop: _value.stopAt,
    });
    updateHistory(
      "compressionsAbs", //key
      _value.startAt, //tiempo
      "Compresiones abdominales" // titulo
    );
  };

  /**
   * Handle utilizado para gestionar la accion de detener
   * del cronometro del boton COMPRESIONES
   *
   * @function handleCheckVentilationStopCounter
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleCheckVentilationStopCounter = (
    _value = defaultTimerHandleValue
  ) => {
    updateContextPush("compressionsAbs", {
      start: _value.startAt,
      stop: _value.stopAt,
    });

    updateHistory(
      "compressionsAbs", //key
      _value.stopAt, //tiempo
      "Compresiones abdominales" // titulo
    );
  };

  /**
   * Handle utilizado para gestionar la accion de detener
   * del cronometro del boton COMPRESIONES
   *
   * @function handleStopTimerCompressions
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStopTimerCompressions = (_value = defaultTimerHandleValue) => {
    updateHistory(
      "compressionsThorax", //key
      _value.stopAt, //tiempo
      "Detiene compresiones torácicas" // titulo
    );
  };

  /**
   * Handle utilizado para gestionar la accion del inicio
   * del cronometro del boton COMPRESIONES
   *
   * @function handleStartTimerCompression
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStartTimerCompression = (_value = defaultTimerHandleValue) => {
    updateHistory(
      "compressionsThorax", //key
      _value.startAt, //tiempo
      "Inicia compresiones torácicas" // titulo
    );
  };

  const handleStartBasic = () => {
    navigation("/basicOvace", { state: { timeline: ctxTimeline } });
  };
  /**
   * Handle utilizado para gestionar
   * la accion CLICK de confirmacion para
   * guardar las notas
   *
   * @function handleDialogConfirmNotes
   */
  const handleDialogConfirmNotes = (text = "") => {
    updateContext("Notas", text);
    if (text != ctxTimeline.Notas) {
      updateHistory(
        "Notas", //key
        +new Date(), //tiempo
        "Notas", // titulo,
        false, // ocultar
        text, // titulo secundario
        "#2AAC9C" // color primario
      );
    }
    handleNotasDialog();
  };

  //#endregion

  //#region ############## FUNCIONES AVANZADAS ##############//
  /**
   * Verifica si el informe ya se ha guardado en la base de datos.
   * @async
   * @function reportExist
   * @todo
   * api que verifique la existencia de un reporte
   *
   */
  const reportExist = async () => {
    const url = `${BASEURLAPI}/caseExist`; //la url para la solicitud
    let result = false;
    await axios
      .get(url)
      .then((response) => {
        if (response.status == 200) {
          if (response.data.result == true) {
            result = true;
          }
        }
      })
      .catch((error) => {
        console.log("hubo un error", error);
      });

    return result;
  };

  /**
   * Guarda el ingorme en la base de datos una vez finalizado el caso.
   *
   * @function SaveReport
   * @todo
   * verificar si el informe ya existe
   */

  const SaveReport = async () => {
    try {
      console.log("Iniciando guardado de informe...");
      console.log("Contexto timeline original:", ctxTimeline);

      // Obtener informes existentes
      const existingReportsStr = localStorage.getItem("reports");
      console.log("Informes existentes en localStorage:", existingReportsStr);

      const existingReports = existingReportsStr
        ? JSON.parse(existingReportsStr)
        : [];
      console.log("Informes parseados:", existingReports);

      // Crear nuevo informe con datos serializables
      const newReport = {
        id: +new Date(),
        name: ctxTimeline.name || "Informe",
        timeline: {
          name: ctxTimeline.name || "Informe",
          type: ctxTimeline.type || "ovace",
          date: ctxTimeline.date || +new Date(),
          history: ctxTimeline.history || [],
          startCase: ctxTimeline.startCase || null,
          stopCase: ctxTimeline.stopCase || null,
          PCR: ctxTimeline.PCR || [],
          RCE: ctxTimeline.RCE || [],
          isSafeScene: ctxTimeline.isSafeScene || false,
          shoutedHelp: ctxTimeline.shoutedHelp || false,
          consistency: ctxTimeline.consistency || null,
          notRespond: ctxTimeline.notRespond || null,
          openAirWay: ctxTimeline.openAirWay || [],
          checkVentilation: ctxTimeline.checkVentilation || [],
          notifiesEmergencyTeam: ctxTimeline.notifiesEmergencyTeam || null,
          lateralSafetyPosition: ctxTimeline.lateralSafetyPosition || null,
          RCP: ctxTimeline.RCP || [],
          DEA: ctxTimeline.DEA || [],
          compressions: ctxTimeline.compressions || [],
          vents: ctxTimeline.vents || [],
          defibrillation: ctxTimeline.defibrillation || [],
          adrenalin: ctxTimeline.adrenalin || [],
          amiodarone: ctxTimeline.amiodarone || [],
          naloxone: ctxTimeline.naloxone || [],
          diazepam: ctxTimeline.diazepam || [],
          vascularAccess: ctxTimeline.vascularAccess || false,
          otDevice: ctxTimeline.otDevice || null,
          monitor: ctxTimeline.monitor || [],
          complete: ctxTimeline.complete || false,
          conscious: ctxTimeline.conscious || false,
          toser: ctxTimeline.toser || null,
          backBlows: ctxTimeline.backBlows || [],
          compressionsAbs: ctxTimeline.compressionsAbs || [],
          compressionsThorax: ctxTimeline.compressionsThorax || [],
          basicVitalSupport: ctxTimeline.basicVitalSupport || null,
          Ritmo: ctxTimeline.Ritmo || [],
          ECG: ctxTimeline.ECG || "",
          ecgPaciente: ctxTimeline.ecgPaciente || "",
          CausaT: ctxTimeline.CausaT || [],
          CausaH: ctxTimeline.CausaH || [],
          Tecnicas: ctxTimeline.Tecnicas || [],
          Farmacos: ctxTimeline.Farmacos || [],
          Notas: ctxTimeline.Notas || [],
          deficit: ctxTimeline.deficit || [],
          calidadRcp: ctxTimeline.calidadRcp || [],
          nonTechnical: ctxTimeline.nonTechnical || [],
          rcpQuality: ctxTimeline.rcpQuality || [],
          asyncDevice: ctxTimeline.asyncDevice || false,
        },
        duration: 0,
        date: new Date().toISOString(),
      };

      console.log("Nuevo informe a guardar:", newReport);

      // Añadir nuevo informe al array
      existingReports.push(newReport);
      console.log("Array de informes actualizado:", existingReports);

      // Guardar en localStorage
      const reportsToSave = JSON.stringify(existingReports);
      console.log("Datos serializados a guardar:", reportsToSave);

      localStorage.setItem("reports", reportsToSave);
      console.log("Informe guardado exitosamente");

      // Verificar que se guardó correctamente
      const savedReports = JSON.parse(localStorage.getItem("reports"));
      console.log("Verificación de datos guardados:", savedReports);

      // Resetear timeline y cerrar diálogo
      setCtxTimeline(TimelineDefault);
      setIsPopupFinish(false);
      setIsPopupFinishStop(false);
      setIsStarted(false);
      setForceStopCase(false);
      setCurrentTimerHandleValue(defaultTimerHandleValue);
      setCurrentTimerHandleValuePCR(defaultTimerHandleValue);
      setCurrentTimerHandleValueCompressions(defaultTimerHandleValue);
      setCurrentTimerHandleValueVents(defaultTimerHandleValue);
      setCurrentTimerHandleValueRcp(defaultTimerHandleValue);
      setCurrentTimerHandleValueDefibrillation(defaultTimerHandleValue);
      setCurrentTimerHandleValueOpenAirWay(defaultTimerHandleValue);
      setCurrentTimerHandleValueCheckVentilation(defaultTimerHandleValue);
    } catch (error) {
      console.error("Error al guardar el informe:", error);
      console.error("Stack trace:", error.stack);
    }
  };

  /**
   * Actualizar el contexto de forma mas simple pasandole el key y el valor
   *
   * @function updateContext
   * @param key string - mandatory
   * @param value any - nulleable
   */
  const updateContext = (key, value = null) => {
    if (DEVMODE) {
      console.log(
        "%cACTUALIZANDO CONTEXTO, Agregando el objeto " + key + " con valor: ",
        "color:#5f5",
        value
      );
    }
    setCtxTimeLine((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  /**
   * Actualizar un elemento del contexto de forma mas simple pasandole el valor
   *
   * @function updateContextPush
   * @param key string - mandatory
   * @param value any - nulleable
   */
  const updateContextPush = (key, value = null) => {
    if (DEVMODE) {
      console.log(
        "%cAGREGANDO AL CONTEXTO PUSH, Agregando el objeto " +
          key +
          " con valor: " +
          value,
        "color:orange"
      );
    }
    setCtxTimeLine((prev) => ({
      ...prev,
      [key]: [...prev[key], value],
    }));
  };

  /**
   * Actualizar el historial de forma mas simple pasandole parametros especificos
   *
   * @function updateHistory
   * @param _object string - nulleable - nombre del key en el contextTimeline de 1er nivel
   * @param _time Date - nulleable - datetime
   * @param _title string - nulleable - titulo que aparece en el reporte
   * @param _hideOnReport boolean - nulleable - si se mostrara o no en el reporte
   * @param _value string - nulleable - valor secundario en el reporte
   * @param _colorPrimario string - nulleable - color del texto secundario
   * @param _colorSecundario string - nulleable - color secundario del texto secundario
   */
  const updateHistory = (
    _object = "",
    _time = +new Date(),
    _title = "-",
    _hideOnReport = false,
    _value = null,
    _colorPrimario = null,
    _colorSecundario = null
  ) => {
    if (DEVMODE) {
      console.log(
        "%cACTUALIZANDO HISTORIAL, Agregando el objeto " + _object,
        "color:yellow"
      );
    }
    setHistory((prev) => [
      ...prev,
      {
        object: _object,
        time: _time,
        title: _title,
        value: _value,
        colorPrimario: _colorPrimario,
        hideOnReport: _hideOnReport,
        colorSecundario: _colorSecundario,
      },
    ]);
  };
  //#endregion

  //#region ############## USEEFFECTS ##############//

  // Hook que se ejecuta al montar el componente para verificar el contexto el tipo de caso advance .
  useEffect(() => {
    updateContext("type", "ovace");
  }, []);

  // Hook que se ejecuta al montar el componente y actualiza el historial en el cotexto
  useEffect(() => {
    updateContext("history", History);
  }, [History]);
  //#endregion

  return (
    <>
      <Loader status={isLoading} text={loadingText} />
      <div className="min-h-screen w-screen flex flex-col bg-[#EAF7F5] overflow-y-auto">
        <Header minimal={true} variant={"ovace"} />
        {
          //#region  TEMPORIZADORES GENERALES
        }
        <div
          className="flex gap-5 py-3 lg:mb-2 relative z-[300] bg-[#F9FAFB] justify-center"
          style={{ boxShadow: "0 4px 6px 0 #2AAC9C33" }}
        >
          <NSTimer
            titleOn="Parar caso" //Titulo cuando su estado es activo
            titleOff="Iniciar caso" //Titulo cuando su estado esta inactivo - por defecto
            onStartTimer={handleStartTimerCase} //Accion al INICIAR el temporizador
            onStopTimer={handleStopTimerCase} //Accion al DETENER el temporizador
            forceDisable={ForceStopCase} //Forzar la desactivacion la accion de este componente
            forceStop={ForceStopCase} //Forzar DETENER el temporizador
          />
          <NSTimer
            titleOn="RCE" //Titulo cuando su estado es activo
            titleOff="Iniciar PCR" //Titulo cuando su estado esta inactivo - por defecto
            onStartTimer={handleStartTimerPCR} //Accion al INICIAR el temporizador
            onStopTimer={handleStopTimerPCR} //Accion al DETENER el temporizador
            forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
            forceStop={ForceStopCase} //Forzar DETENER el temporizador
          />
        </div>
        <div
          className={`w-full ${
            isMobile && !isTablet ? "px-[16px]" : "px-[26px]"
          }`}
        >
          {
            //#endregion
            //#region  BOTONES SWITCH
          }
          <div className="flex flex-1 gap-2 py-6 justify-start">
            <NSToggle
              titles={["Incompleta", "Completa"]} //Titulo visible
              initialState={complete ? 1 : 0}
              onClick={handleCompleteToggle} //Accion cuando se hace CLICK
              forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
              forceStop={ForceStopCase} //Forzar DETENER el temporizador
            />
            <NSToggle
              titles={["Inconsciente", "Consciente"]} //Titulo visible
              initialState={conscious ? 1 : 0}
              onClick={handleConsciousToggle} //Accion cuando se hace CLICK
              forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
              forceStop={ForceStopCase} //Forzar DETENER el temporizador
            />
          </div>

          {
            //#endregion
            //#region  BOTONES VARIABLES DEL CONTENIDO
          }
          <div className="flex w-full justify-center">
            <div
              className={` inline-grid gap-4 justify-center  ${
                isMobile && !isTablet ? "grid-cols-2" : "grid-cols-3"
              }`}
              style={styles.buttonsSeccion}
            >
              <NSBoolean
                title={"Animar a toser"} //Titulo visible
                icon={Ic_tos} //Icono del componente
                initialState={false} //Estado inicial del componente
                onClick={hanldeNotResposeButton} //Accion cuando se hace CLICK
                forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                minimal={PlatformMobile}
              />
              <NSBoolean
                title={"Avisa equipo emergencias"} //Titulo visible
                icon={iconAvisaEquipo} //Icono del componente
                initialState={false} //Estado inicial del componente
                onClick={hanldeNotifiesEmergencyTeamButton} //Accion cuando se hace CLICK
                forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                minimal={PlatformMobile}
              />
              <NSCounter
                titleStart={"Golpes espalda"} //Titulo por defecto cuando inicializa
                titleOn={"Golpes espalda"} //Titulo cuando su estado esta activo
                titleOff={"Golpes espalda"} //Titulo cuando su estado esta INACTIVO
                icon={Ic_golpesespalda} //Icono del componente
                type={"restart"} //tipo de componente personalizado
                sum={1} //valor a sumar en el inicio del componente
                onStopTimer={handleOpenAirWayStopCounter} //Accion al DETENER el temporizador
                onStartTimer={handleOpenAirWayStartCounter} //Accion al INICIAR el temporizador
                list={ctxTimeline.openAirWay} //Lista de contexto para el conteo de elementos
                forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                onlyCounter //Oculta el Temporizador y solo muestra el contador
                minimal={PlatformMobile}
              />
              <NSCounter
                titleStart={"Compresiones abdominales"} //Titulo por defecto cuando inicializa
                titleOn={"Compresiones abdominales"} //Titulo cuando su estado esta activo
                titleOff={"Compresiones abdominales"} //Titulo cuando su estado esta INACTIVO
                icon={null} //Icono del componente
                type={"restart"} //tipo de componente personalizado
                sum={1} //valor a sumar en el inicio del componente
                onStopTimer={handleCheckVentilationStopCounter} //Accion al DETENER el temporizador
                onStartTimer={handleCheckVentilationStartCounter} //Accion al INICIAR el temporizador
                list={ctxTimeline.checkVentilation} //Lista de contexto para el conteo de elementos
                forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                onlyCounter //Oculta el Temporizador y solo muestra el contador
                minimal={PlatformMobile}
              />

              <NSCounter
                titleStart={"Compresiones torácicas"} //Titulo por defecto cuando inicializa
                titleOn={"Compresiones torácicas"} //Titulo cuando su estado esta activo
                titleOff={"Compresiones torácicas"} //Titulo cuando su estado esta INACTIVO
                icon={iconNino} //Icono del componente
                sum={1} //valor a sumar en el inicio del componente
                onStopTimer={handleStopTimerCompressions} //Accion al DETENER el temporizador
                onStartTimer={handleStartTimerCompression} //Accion al INICIAR el temporizador
                list={ctxTimeline.compressions} //Lista de contexto para el conteo de elementos
                forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                noCounter //Oculta el Temporizador y solo muestra el contador
                initialState //Estado inicial del componente
                minimal={PlatformMobile}
              />

              <NSIndicator
                title={"Notas"} //Titulo por defecto cuando inicializa
                icon={iconNotas} //Icono del componente
                values={[{ status: ctxTimeline.Notas == "" ? false : true }]} //Valores personalizados del componente
                options={ComponentOptions.notesButton} //Opciones personalizadas del componente
                onClick={() => {
                  handleNotasDialog();
                }} //Accion cuando se hace CLICK
                forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                initialState //Estado inicial del componente
                minimal={PlatformMobile}
              />
            </div>
          </div>
          <div className="flex items-center justify-center mt-10 pb-40">
            <OutlinedButton
              icon={Ic_exit_green} //Icono del componente
              variant={"outlined"} //Tipo de botonb
              title={"Inicia soporte vital básico"} //Titulo por defecto cuando inicializa
              initialState={IsStarted} //Estado inicial del componente
              onClick={handleStartBasic} //Accion de respuesta al boton
            />
          </div>
        </div>
      </div>
      {
        //#endregion
      }

      {
        //#endregion
      }

      <div style={styles.footer}>
        <SimpleButton
          text={T("informe")}
          onClick={handleDialogFinish}
          disabled={!ForceStopCase}
          variant="white"
        />
      </div>
      {
        //#region DIALOGOS POPUP
      }

      <DialogPediatrico
        text={"patient_type_question"}
        callbackConfirm={handleCompresions}
        callbackCancel={handleCloseDialog}
        status={IsPopupComp}
      />
      {IsPopupNotas && (
        <DialogDownNotes
          text={"Notas"} //Titulo por defecto cuando inicializa
          icon={iconNotas} //Icono del componente
          callbackConfirm={handleDialogConfirmNotes} //Accion cuando se presiona CONFIRMAR
          callbackCancel={handleNotasDialog} //Accion cuando se presiona CANCELAR
          status={IsPopupNotas} //Estado del compononte (Visible || oculto)
          contexto={ctxTimeline}
        />
      )}
      <DialogHabilidades
        text={"tech_skills_question"} //Titulo por defecto cuando inicializa
        callbackConfirm={handleStop} //Accion cuando se presiona CONFIRMAR
        callbackCancel={() => setIsPopupHabilidades(false)} //Accion cuando se presiona CANCELAR
        status={ForceStopCase && IsPopupHabilidades} //Estado del compononte (Visible || oculto)
        action01={() => handleDialogNoTecnicas()} //Accion al presionar el PRIMER boton
        action02={() => handleDialogCalidadRcp()} //Accion al presionar el SEGUNDO boton
        action03={() => handleDialogMedirAmbas()} //Accion al presionar el TERCER boton
        action04={() => {
          handleDialogFinish(); //Abre el PopUp para finalizar el registro
          setIsPopupHabilidades(false); // cierra el popup de habilidades
        }} //Accion al presionar el CUARTO boton
      />
      <DialogNoTecnicas
        callbackConfirm={() => {}} //Accion cuando se presiona CONFIRMAR
        callbackCancel={() => handleDialogNoTecnicasStop()} //Accion cuando se presiona CANCELAR
        status={IsPopUpNoTecnicas} //Estado del compononte (Visible || oculto)
        volverNoTecnicas={() => handleVolverNoTecnicas()} //Accion al presionar VOLVER en No Tecnicas
        actionNoTecnicas={() => handleSaveAndCloseNotecnicas()} //Accion al presionar GUARDAR en No Tecnicas
        saveAnd={"Guardar y generar informe"} //Titulo personalizado del boton guardar
      />

      <DialogCalidadRcp
        callbackConfirm={() => {}} //Accion cuando se presiona CONFIRMAR
        callbackCancel={() => handleDialogCalidadRcpStop()} //Accion cuando se presiona CANCELAR
        status={IsPopUpCalidadRcp} //Estado del compononte (Visible || oculto)
        volverCalidadRcp={() => handleVolverCalidadRcp()} //Accion al presionar VOLVER en calidad RCP
        actionCalidadRcp={() => handleSaveAndCloseCalidadRcp()} //Accion al presionar GUARDAR en calidad RCP
        saveAnd={"Guardar y generar informe"} //Titulo personalizado del boton guardar
      />
      <DialogMedirAmbas
        callbackConfirm={handleDialogMedirAmbasConfirm} //Accion cuando se presiona CONFIRMAR
        callbackCancel={handleMedirAmbasStop} //Accion cuando se presiona CANCELAR
        status={IsPopUpMedirAmbas} //Estado del compononte (Visible || oculto)
      />
      {IsPopUpFinish && (
        <DialogFinish
          onSaveReport={() => SaveReport()} //Accion cuando se presiona CONFIRMAR
          callbackCancel={handleDialogFinishStop} //Accion cuando se presiona CANCELAR
          selectedReport={ctxTimeline} //Pasar por props el reporte seleccionado
          onUpdateContext={updateContext}
        />
      )}
      {
        //#endregion
      }
    </>
  );
};
export default Ovace;

//#region TABLA DE ESTILOS
const styles = {
  bodyContent: {
    display: "flex",
    zIndex: 0,
    background: "#eaf7f5",
    overflowY: "auto",
    height: "100%",
    minHeight: "70vh",
    maxHeight: "70vh",
  },
  footer: {
    bottom: 0,
    position: "fixed",
    width: "100%",
    height: "80px",
    background: "#2AAC9C",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
//#endregion
